import React, { useEffect, useState } from 'react';
import { IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import './ConsentBanner.css';

export type ConsentChoice = { version: 1; externalMedia: boolean; decidedAt: string };
export const CONSENT_STORAGE_KEY = 'pawerlifting-consent-v1';
export const CONSENT_EVENT = 'pawerlifting-consent-changed';

export const readConsent = (): ConsentChoice | null => {
  try { return JSON.parse(localStorage.getItem(CONSENT_STORAGE_KEY) || 'null'); }
  catch { return null; }
};

const ConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(() => !readConsent());
  const history = useHistory();

  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener('pawerlifting-open-consent', open);
    return () => window.removeEventListener('pawerlifting-open-consent', open);
  }, []);

  const save = (externalMedia: boolean) => {
    const choice: ConsentChoice = { version: 1, externalMedia, decidedAt: new Date().toISOString() };
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(choice));
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: choice }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="consent-banner" role="dialog" aria-modal="true" aria-labelledby="consent-title">
      <div className="consent-banner__copy">
        <span>Your privacy</span>
        <h2 id="consent-title">Local first, with a choice for external media.</h2>
        <p>Essential storage keeps sign-in, security preferences and local app data working. It cannot be disabled. YouTube execution videos may contact Google only if you allow external media or load an individual video.</p>
        <div className="consent-banner__links">
          <button onClick={() => history.push('/privacy')}>Privacy policy</button>
          <button onClick={() => history.push('/imprint')}>Imprint</button>
        </div>
      </div>
      <div className="consent-banner__actions">
        <IonButton shape="round" fill="outline" onClick={() => save(false)}>Only essential</IonButton>
        <IonButton shape="round" onClick={() => save(true)}>Allow external media</IonButton>
      </div>
    </aside>
  );
};

export default ConsentBanner;
